// src/pages/DashboardPage.jsx
import Layoutpp from "../layouts/Layoutpp";
import EditJobRequirement from "./EditJobRequirement ";

const Jobdet = () => {

  return (
    <Layoutpp title="Job Details">
        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <EditJobRequirement/>
        </div>
    </Layoutpp>
  );
};

export default Jobdet;
